"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var setBlockedSendersOption_1 = require("../actions/setBlockedSendersOption");
var store_1 = require("../store/store");
var owa_junkmail_configuration_1 = require("owa-junkmail-configuration");
var owa_options_core_1 = require("owa-options-core");
var owa_options_strings_1 = require("owa-strings/owa-options-strings");
var React = require("react");
var react_1 = require("satcheljs/lib/legacy/react");
var owa_mail_option_common_1 = require("owa-mail-option-common");
var owa_options_controls_1 = require("owa-options-controls");
var BlockedSendersFull = /** @class */ (function (_super) {
    tslib_1.__extends(BlockedSendersFull, _super);
    function BlockedSendersFull() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onChangeBlockedSenders = function (blockedSenders) {
            setBlockedSendersOption_1.default(blockedSenders);
        };
        return _this;
    }
    BlockedSendersFull.prototype.render = function () {
        var senders = owa_options_core_1.getFallbackValueIfNull(this.props.optionState.blockedSenders, this.props.junkEmailConfiguration.BlockedSendersAndDomains.filter(function (item) {
            return owa_mail_option_common_1.isEmailAddress(item);
        }));
        return (React.createElement("div", null, senders && (React.createElement("div", null,
            React.createElement(owa_options_controls_1.OptionDescription, null, owa_options_strings_1.default.options_junkEmail_blockedSenders),
            React.createElement(owa_mail_option_common_1.EditSendersAndDomains, { items: senders, onItemsChanged: this.onChangeBlockedSenders, mode: 0 /* EmailAddressOnly */ })))));
    };
    BlockedSendersFull = tslib_1.__decorate([
        react_1.reactive({
            optionState: function () { return store_1.default; },
            junkEmailConfiguration: function () { return owa_junkmail_configuration_1.getMailboxJunkEmailConfiguration(); },
        })
    ], BlockedSendersFull);
    return BlockedSendersFull;
}(React.Component));
exports.default = BlockedSendersFull;
//# sourceMappingURL=BlockedSendersFull.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-blocked-senders-option/lib/components/BlockedSendersFull.js
// module id = 5036
// module chunks = 2